import { get } from "http";
import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { AppDispatch, store } from "../../store";
// utils
import axiosInstance from "../../../api/manageServer";
import toast from "react-hot-toast";
import { setCart, setCartItems } from "../cart/cartSlice";
import { redirect } from "react-router-dom";
import { Order } from "../../../@types/order";
import { setPaginationOption } from "../filter/filterSlice";

// ----------------------------------------------------------------------

const initialState: any = {
  isLoading: false,
  error: false,
  orders: [],
  order: null,
  cancelOrder: null,
};

const slice = createSlice({
  name: "order",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      state.error = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = true;
    },

    // GET ORDERS
    getOrdersSuccess(state, action) {
      state.isLoading = false;
      state.orders = action.payload;
    },

    // GET ORDER
    getOrderSuccess(state, action) {
      state.isLoading = false;
      state.order = action.payload;
    },

    cancelOrderSuccess(state, action) {
      state.isLoading = false;
      state.cancelOrder = action.payload;
    },
    endLoading(state) {
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

const { actions } = slice;
// ----------------------------------------------------------------------

export function getFilterOrders(filters: any) {
  // console.log("🚀 ~ filters:", filters);
  // const { dispatch, getState } = store;
  return async (dispatch: any, getState: () => any) => {
    const paginationOption = getState().filter.paginationOption;

    try {
      dispatch(actions.startLoading());

      // Retrieve userId from auth state
      const userId = getState().auth.auth?.userId;
      if (!userId) {
        throw new Error("User ID is missing. Please log in.");
      }

      let req = `userId=${userId}`;
      // console.log(filters);

      req +=
        filters?.type === "paymentGatewayStatus"
          ? `&paymentGatewayStatus=${
              filters?.value !== "All" ? filters.value : ""
            }`
          : `&deliveryStatus=${filters?.value !== "All" ? filters.value : ""}`;

      // Ensure filters is an array before using forEach
      if (Array.isArray(filters)) {
        filters.forEach((filter: any) => {
          if (filter?.title === "User") {
            filter.filters.forEach((item: any) => {
              if (item?.selected) {
                req += `&userId=${item?.value}`;
              }
            });
          }
          if (filter?.title === "Payment Type") {
            filter.filters.forEach((item: any) => {
              if (item?.selected) {
                req += `&paymentType=${encodeURIComponent(item?.value)}`;
              }
            });
          }
          if (filter?.title === "Delivery Status") {
            filter.filters.forEach((item: any) => {
              if (item?.selected) {
                req += `&deliveryStatus=${encodeURIComponent(item?.value)}`;
              }
            });
          }
        });
      }

      // Add pagination options
      if (paginationOption?.page) {
        req += `&pageCount=${paginationOption?.page}`;
      }
      if (paginationOption?.pageSize) {
        req += `&pageSize=${paginationOption?.pageSize}`;
      }

      const response = await axiosInstance.get(`/order/filter?${req}`);
      // console.log(response.data);
      if (response?.status === 200) {
        dispatch(actions.getOrdersSuccess(response.data.records));
        dispatch(
          setPaginationOption({
            page: response.data.pageNumber,
            pageSize: response.data.pageSize,
            totalPages: response.data.totalPages,
            totalRecords: response.data.totalRecords,
          })
        );
        return;
      } else {
        dispatch(actions.hasError("Failed to fetch orders"));
      }
    } catch (error) {
      console.error(error);
      dispatch(actions.hasError);
    }
  };
}

export function fetchOrderById(id: number) {
  return async (dispatch: Dispatch) => {
    dispatch(actions.startLoading());
    try {
      const response = await axiosInstance.get(`/order/${id}`);

      // console.log(response, "fjhgfj");

      dispatch(actions.getOrderSuccess(response.data));
    } catch (error) {
      // Handle error and dispatch the error action
      console.log("Error fetching similar order data:", error);
      dispatch(actions.hasError(error));
    }
  };
}

export function storeOrder(data: any) {
  // const { dispatch } = store;
  return async (dispatch: any, getState: () => any) => {
    dispatch(actions.startLoading());
    try {
      const response = await axiosInstance.post(`/order`, data);
      // console.log(response);

      if (response?.data?.success) {
        toast.success(response?.data?.message);
        dispatch(actions.getOrderSuccess(response.data.order));
        dispatch(setCart([]));
        dispatch(setCartItems([]));
        return response.data;
      } else {
        toast.error(response?.data?.message);
        dispatch(actions.hasError(response?.data?.message));
        dispatch(actions.hasError(response?.data?.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(actions.hasError(error));
    }
  };
}

export function cancelOrderById(id: number) {
  return async (dispatch: Dispatch, getState: () => any) => {
    // dispatch(actions.startLoading());
    try {
      const userId = getState().auth.auth?.userId;
      if (!userId) {
        toast.error("Seems like you are not logged in. Please log in.");
        // dispatch(actions.endLoading());
        return;
      }
      const response = await axiosInstance.put(
        `/delivery/status?orderId=${id}&deliveryStatus=CANCELLED&updaterId=${userId}`
      );

      if (response?.data?.success) {
        toast.success(response?.data?.message);
        dispatch(actions.cancelOrderSuccess(response.data));
      } else {
        toast.error(response?.data?.message);
        dispatch(actions.hasError(response?.data?.message));
      }

      return response.data;
    } catch (error) {
      // Handle error and dispatch the error action
      console.log("Error fetching similar order data:", error);
      dispatch(actions.hasError(error));
    }
  };
}
